export default "__VITE_ASSET__74fd2d4d__"